/* ==========================================================================
   ODYSSÉE PRESTIGE — THEME.JS
   ========================================================================== */

(function () {
  'use strict';

  /* ---------- Helpers ---------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- Mobile menu ---------- */
  var menuToggle = qs('[data-menu-toggle]');
  var menuClose = qs('[data-menu-close]');
  var mobileMenu = qs('[data-mobile-menu]');
  var menuOverlay = qs('[data-menu-overlay]');

  function openMenu() {
    mobileMenu && mobileMenu.classList.add('is-open');
    menuOverlay && menuOverlay.classList.add('is-open');
    menuToggle && menuToggle.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeMenu() {
    mobileMenu && mobileMenu.classList.remove('is-open');
    menuOverlay && menuOverlay.classList.remove('is-open');
    menuToggle && menuToggle.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
  }
  menuToggle && menuToggle.addEventListener('click', openMenu);
  menuClose && menuClose.addEventListener('click', closeMenu);
  menuOverlay && menuOverlay.addEventListener('click', closeMenu);

  /* ---------- Search drawer ---------- */
  var searchToggle = qs('[data-search-toggle]');
  var searchClose = qs('[data-search-close]');
  var searchDrawer = qs('[data-search-drawer]');
  var searchOverlay = qs('[data-search-overlay]');
  var searchInput = qs('[data-search-input]');

  function openSearch() {
    searchDrawer && searchDrawer.classList.add('is-open');
    searchOverlay && searchOverlay.classList.add('is-open');
    setTimeout(function () { searchInput && searchInput.focus(); }, 250);
  }
  function closeSearch() {
    searchDrawer && searchDrawer.classList.remove('is-open');
    searchOverlay && searchOverlay.classList.remove('is-open');
  }
  searchToggle && searchToggle.addEventListener('click', openSearch);
  searchClose && searchClose.addEventListener('click', closeSearch);
  searchOverlay && searchOverlay.addEventListener('click', closeSearch);

  /* ---------- Cart drawer ---------- */
  var cartDrawer = qs('[data-cart-drawer]');
  var cartOverlay = qs('[data-cart-overlay]');
  var cartClose = qs('[data-cart-close]');
  var cartToggleBtns = qsa('[data-cart-toggle]');
  var cartCountEls = qsa('[data-cart-count]');
  var drawerEnabled = document.body.dataset.cartDrawer !== 'false';

  function openCart() {
    cartDrawer && cartDrawer.classList.add('is-open');
    cartOverlay && cartOverlay.classList.add('is-open');
  }
  function closeCart() {
    cartDrawer && cartDrawer.classList.remove('is-open');
    cartOverlay && cartOverlay.classList.remove('is-open');
  }
  cartToggleBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      if (cartDrawer) {
        e.preventDefault();
        openCart();
      }
    });
  });
  cartClose && cartClose.addEventListener('click', closeCart);
  cartOverlay && cartOverlay.addEventListener('click', closeCart);

  /* ---------- Escape key closes any open panel ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeMenu();
      closeSearch();
      closeCart();
    }
  });

  /* ---------- Add to cart (AJAX) ---------- */
  function updateCartCount(count) {
    cartCountEls.forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-cart-count', count);
    });
  }

  function refreshCartDrawer() {
    fetch('/?section_id=cart-drawer')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newDrawer = doc.querySelector('[data-cart-drawer]');
        if (newDrawer && cartDrawer) {
          cartDrawer.innerHTML = newDrawer.innerHTML;
        }
      })
      .catch(function () {});
  }

  qsa('form[action*="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!drawerEnabled) return; // let it submit normally
      e.preventDefault();
      var formData = new FormData(form);
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) { submitBtn.disabled = true; }

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          refreshCartDrawer();
          openCart();
        })
        .catch(function () {
          form.submit();
        })
        .finally(function () {
          if (submitBtn) { submitBtn.disabled = false; }
        });
    });
  });

  /* ---------- Product gallery ---------- */
  qsa('[data-product-gallery]').forEach(function (gallery) {
    var slides = qsa('.product-gallery__slide', gallery);
    var thumbs = qsa('[data-thumb]', gallery);
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = thumb.getAttribute('data-index');
        slides.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-index') === index); });
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
      });
    });
  });

  /* ---------- Sticky header shadow on scroll ---------- */
  var header = qs('[data-header]');
  if (header) {
    var lastScroll = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      header.style.boxShadow = y > 4 ? '0 1px 0 rgba(255,255,255,.04)' : 'none';
      lastScroll = y;
    }, { passive: true });
  }
})();
